import {
  QuoteAccessories,
  QuoteAccessoryTableRow,
  QuoteBoxStructure,
  QuoteCrossBeams,
  QuoteDetailsSummary,
  QuoteOptionItem,
  QuoteQuotationForm,
  QuoteSelectOption,
} from "./types";

const option = (value: string, labelKey: string): QuoteSelectOption => ({
  value,
  labelKey,
});

export const CUSTOMER_OPTIONS: QuoteSelectOption[] = [
  option("galon", "QUOTES.MOCK.CUSTOMER.GALON"),
  option("a-ladani", "WORK_ORDER.VEHICLE_DETAILS.CUSTOMER_VALUES.A_LADANI"),
  option(
    "shlomo",
    "WORK_ORDER.VEHICLE_DETAILS.CUSTOMER_VALUES.SHLOMO_LOGISTICS"
  ),
];

export const SUB_CUSTOMER_OPTIONS: QuoteSelectOption[] = [
  option("branch-a", "QUOTES.MODAL.OPTIONS.SUB_CUSTOMER.BRANCH_A"),
  option("branch-b", "QUOTES.MODAL.OPTIONS.SUB_CUSTOMER.BRANCH_B"),
];

export const MANUFACTURER_OPTIONS: QuoteSelectOption[] = [
  option("mercedes", "MANUFACTURERS.DATA.MERCEDES"),
  option("man", "MANUFACTURERS.DATA.MAN"),
  option("volvo", "MANUFACTURERS.DATA.VOLVO"),
  option("daf", "MANUFACTURERS.DATA.DAF"),
];

export const MODEL_OPTIONS: QuoteSelectOption[] = [
  option("actros", "QUOTES.MODAL.OPTIONS.MODEL.ACTROS"),
  option("tgs", "QUOTES.MODAL.OPTIONS.MODEL.TGS"),
  option("fh", "QUOTES.MODAL.OPTIONS.MODEL.FH"),
];

export const BOX_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("open", "WORK_ORDER.VEHICLE_DETAILS.BOX_TYPE_VALUES.OPEN_BOX"),
  option("closed", "WORK_ORDER.VEHICLE_DETAILS.BOX_TYPE_VALUES.CLOSED_BOX"),
  option(
    "refrigerated",
    "WORK_ORDER.VEHICLE_DETAILS.BOX_TYPE_VALUES.REFRIGERATED"
  ),
];

export const mockQuoteDetails: QuoteDetailsSummary = {
  workOrderNo: "13487",
  customerNameKey: "WORK_ORDER.VEHICLE_DETAILS.CUSTOMER_VALUES.A_LADANI",
  subCustomerKey: "WORK_ORDER.VEHICLE_DETAILS.CUSTOMER_VALUES.A_LADANI",
  chassis: "9368474",
  manufacturerKey: "WORK_ORDER.VEHICLE_DETAILS.MANUFACTURER_VALUES.SCANIA",
  model: "P 420 B6x2*4NA",
  axleConfiguration: "6x2",
  year: "2017",
  boxTypeKey: "WORK_ORDER.VEHICLE_DETAILS.BOX_TYPE_VALUES.OPEN_BOX",
  totalSale: 0,
  theoreticalPrice: 0,
  totalCost: 0,
  totalMaterialCost: 0,
  profitAmount: 0,
  profitPercent: 0,
};

export const FLOOR_BASE_OPTIONS: QuoteSelectOption[] = [
  option("Z220", "QUOTES.DETAILS.FORM.OPTIONS.FLOOR_BASE_Z220"),
];

export const CURTAIN_FLOOR_BASE_OPTIONS: QuoteSelectOption[] = [
  option("U65", "QUOTES.DETAILS.FORM.OPTIONS.FLOOR_BASE_U65"),
];

export const FLOOR_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("BLACK_SHEET", "QUOTES.DETAILS.FORM.OPTIONS.FLOOR_TYPE_BLACK_SHEET"),
];

const roofCurtainKey = (suffix: string) =>
  `QUOTES.DETAILS.FORM.ROOF_CURTAINS.${suffix}`;

export const CURTAIN_ROOF_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("FIBERGLASS", roofCurtainKey("OPTIONS.FIBERGLASS_ROOF")),
];

export const CURTAIN_ROOF_BEAM_OPTIONS: QuoteSelectOption[] = [
  option("SHEET_200_3", roofCurtainKey("OPTIONS.SHEET_ROOF_BEAM_200_3")),
];

export const CURTAIN_FRONT_WALL_OPTIONS: QuoteSelectOption[] = [
  option("REGULAR_FRONT_WALL", roofCurtainKey("OPTIONS.REGULAR_FRONT_WALL")),
];

export const CURTAIN_REAR_FRAME_OPTIONS: QuoteSelectOption[] = [
  option("REGULAR", roofCurtainKey("OPTIONS.REGULAR")),
];

export const CURTAIN_REAR_OPENING_OPTIONS: QuoteSelectOption[] = [
  option("OPEN", roofCurtainKey("OPTIONS.OPEN")),
];

export const CURTAIN_SIDE_DOOR_OPTIONS: QuoteSelectOption[] = [
  option("TIN_DOOR", roofCurtainKey("OPTIONS.TIN_DOOR")),
];

export const CURTAIN_TENSIONER_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("WIDE", "QUOTES.DETAILS.FORM.TYING_EQUIPMENT.OPTIONS.WIDE"),
];

export const CURTAIN_TOOLBOX_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("SILAGI_SHEET", roofCurtainKey("OPTIONS.SILAGI_SHEET_BOX")),
];

export const CURTAIN_TOOLBOX_SIZE_OPTIONS: QuoteSelectOption[] = [
  option("1200X600X600", roofCurtainKey("OPTIONS.SIZE_1200X600X600")),
];

const closedBoxKey = (suffix: string) =>
  `QUOTES.DETAILS.FORM.CLOSED_BOX.${suffix}`;

export const CLOSED_BODY_HEIGHT_OPTIONS: QuoteSelectOption[] = [
  option("ABOVE_2_44", closedBoxKey("OPTIONS.HEIGHT_ABOVE_2_44")),
];

export const CLOSED_ADJUSTED_HEIGHT_OPTIONS: QuoteSelectOption[] = [
  option("MM", closedBoxKey("OPTIONS.HEIGHT_UNIT_MM")),
];

const insulatedBoxKey = (suffix: string) =>
  `QUOTES.DETAILS.FORM.INSULATED_BOX.${suffix}`;

export const INSULATED_BODY_HEIGHT_OPTIONS: QuoteSelectOption[] = [
  option("ABOVE_2_44", insulatedBoxKey("OPTIONS.HEIGHT_ABOVE_2_44")),
];

export const INSULATED_ROOF_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("INSULATED_40_FIBER", insulatedBoxKey("OPTIONS.INSULATED_ROOF_40_FIBER")),
];

export const INSULATED_REAR_FRAME_OPTIONS: QuoteSelectOption[] = [
  option("REGULAR", insulatedBoxKey("OPTIONS.REGULAR")),
];

export const INSULATED_REAR_OPENING_OPTIONS: QuoteSelectOption[] = [
  option("OPEN", insulatedBoxKey("OPTIONS.OPEN")),
];

export const INSULATED_HYDRAULIC_TON_OPTIONS: QuoteSelectOption[] = [
  option("TON_1", insulatedBoxKey("OPTIONS.TON_1")),
];

export const INSULATED_SIDE_FLAP_OPTIONS: QuoteSelectOption[] = [
  option("REGULAR_GAS_PISTONS", insulatedBoxKey("OPTIONS.REGULAR_GAS_PISTONS")),
];

export const INSULATED_APC_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("TYPE_A", insulatedBoxKey("OPTIONS.TYPE_A")),
];

export const INSULATED_TOOLBOX_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("SILAGI_SHEET", insulatedBoxKey("OPTIONS.SILAGI_SHEET_BOX")),
];

export const INSULATED_TOOLBOX_SIZE_OPTIONS: QuoteSelectOption[] = [
  option("1200X600X600", insulatedBoxKey("OPTIONS.SIZE_1200X600X600")),
];

export const INSULATED_BUMPER_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("REGULAR", insulatedBoxKey("OPTIONS.REGULAR")),
];

export const INSULATED_COOLING_UNIT_OPTIONS: QuoteSelectOption[] = [
  option("THERMO_KING", insulatedBoxKey("OPTIONS.THERMO_KING")),
];

export const CLOSED_ROOF_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("FIBERGLASS", closedBoxKey("OPTIONS.FIBERGLASS_ROOF")),
];

export const CLOSED_FRONT_WALL_OPTIONS: QuoteSelectOption[] = [
  option("REGULAR_FRONT_WALL", closedBoxKey("OPTIONS.REGULAR_FRONT_WALL")),
];

export const CLOSED_REAR_FRAME_OPTIONS: QuoteSelectOption[] = [
  option("REGULAR", closedBoxKey("OPTIONS.REGULAR")),
];

export const CLOSED_REAR_OPENING_OPTIONS: QuoteSelectOption[] = [
  option("OPEN", closedBoxKey("OPTIONS.OPEN")),
];

export const CLOSED_HYDRAULIC_TON_OPTIONS: QuoteSelectOption[] = [
  option("TON_1", closedBoxKey("OPTIONS.TON_1")),
];

export const CLOSED_SIDE_FLAP_OPTIONS: QuoteSelectOption[] = [
  option("REGULAR_GAS_PISTONS", closedBoxKey("OPTIONS.REGULAR_GAS_PISTONS")),
];

export const CLOSED_APC_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("TYPE_A", closedBoxKey("OPTIONS.TYPE_A")),
];

export const CLOSED_TOOLBOX_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("SILAGI_SHEET", closedBoxKey("OPTIONS.SILAGI_SHEET_BOX")),
];

export const CLOSED_TOOLBOX_SIZE_OPTIONS: QuoteSelectOption[] = [
  option("1200X600X600", closedBoxKey("OPTIONS.SIZE_1200X600X600")),
];

export const CLOSED_BUMPER_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("REGULAR", closedBoxKey("OPTIONS.REGULAR")),
];

export const CLOSED_SPARE_WHEEL_OPTIONS: QuoteSelectOption[] = [
  option("LOWER", closedBoxKey("OPTIONS.LOWER")),
];

const boxKey = (suffix: string) =>
  `QUOTES.DETAILS.FORM.BOX_STRUCTURE.${suffix}`;

export const WALL_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("LOW_TIN_PIPES", boxKey("OPTIONS.LOW_TIN_PIPES")),
];

export const PILLAR_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("GAS_MODEL", boxKey("OPTIONS.GAS_MODEL")),
];

export const HYDRAULIC_TYPE_OPTIONS: QuoteSelectOption[] = [
  option("STANDARD", boxKey("OPTIONS.STANDARD")),
];

const optionItem = (
  overrides: Partial<QuoteOptionItem> = {}
): QuoteOptionItem => ({
  enabled: true,
  selectedOption: "",
  note: "",
  quantity: "",
  size: "",
  location: "",
  itemType: "",
  optionEnabled: false,
  ...overrides,
});

export const mockQuoteBoxStructure: QuoteBoxStructure = {
  frontWall: {
    enabled: true,
    selectedOption: "LOW_TIN_PIPES",
    height: "1400",
    treadSurface: true,
    treadNote: "",
    widthReinforcement: true,
    widthNote: "",
  },
  backWall: optionItem({
    selectedOption: "LOW_TIN_PIPES",
    size: "1400",
    optionEnabled: true,
  }),
  frontRack: optionItem(),
  backRack: optionItem(),
  sideDoors: optionItem({ quantity: "400" }),
  pillars: optionItem({ selectedOption: "GAS_MODEL", quantity: "99" }),
  hydraulicSide: optionItem({ selectedOption: "STANDARD" }),
  rearDoor: optionItem(),
};

const tyingKey = (suffix: string) =>
  `QUOTES.DETAILS.FORM.TYING_EQUIPMENT.${suffix}`;

const tableRow = (
  id: string,
  itemType: string,
  quantity: string,
  note = "-",
  height = ""
): QuoteAccessoryTableRow => ({
  id,
  itemType,
  quantity,
  note,
  height,
});

export const QUOTE_EQUIPMENT_TABLE_COLUMNS = {
  itemType: tyingKey("TABLE_COLUMNS.TYPE"),
  height: tyingKey("TABLE_COLUMNS.SIZE"),
  quantity: tyingKey("TABLE_COLUMNS.QUANTITY"),
  note: tyingKey("TABLE_COLUMNS.NOTE"),
} as const;

export const QUOTE_EQUIPMENT_TABLES = [
  {
    tableKey: "toolboxes" as const,
    titleKey: tyingKey("TABLES.TOOLBOXES"),
    columns: ["itemType", "height", "quantity", "note"] as const,
    variant: "toolbox" as const,
  },
  {
    tableKey: "openBasket" as const,
    titleKey: tyingKey("TABLES.OPEN_BASKET"),
    columns: ["itemType", "quantity", "note"] as const,
    variant: "openBasket" as const,
  },
];

export const emptyAccessoryTableRow = (): QuoteAccessoryTableRow =>
  tableRow(`row-${Date.now()}`, "", "", "-", "");

export const mockQuoteAccessories: QuoteAccessories = {
  tyingEquipment: {
    sideCableTensioner: optionItem({ quantity: "99" }),
    strapTensioners: optionItem({ quantity: "99", selectedOption: "WIDE" }),
    frontCableTensioner: optionItem({ quantity: "99" }),
    recessedRings: optionItem({ quantity: "99" }),
    apcRings: optionItem({ quantity: "99" }),
    additionalTyingHooks: optionItem({ quantity: "99" }),
  },
  storageAccessories: {
    polesBasket: optionItem({ quantity: "1" }),
    waterJerrycan: optionItem({ quantity: "1" }),
    palletJackMount: optionItem({ selectedOption: "FROM_SIDE" }),
  },
  tables: {
    toolboxes: [
      tableRow(
        "toolbox-1",
        tyingKey("TABLE_VALUES.TOOLBOX_TYPE"),
        "1",
        "-",
        "1200X600X600"
      ),
    ],
    openBasket: [
      tableRow("open-basket-1", tyingKey("TABLE_VALUES.GAS_MODEL"), "99"),
    ],
  },
  safetyAndStandards: {
    spareWheelCarrier: optionItem({ selectedOption: "REGULAR" }),
    hazardousMaterialsMounts: optionItem(),
    rearBumper: optionItem(),
    couplingLocks: optionItem(),
    extinguisherMounts: optionItem(),
    rearLightMounts: optionItem({ optionEnabled: true }),
  },
  vehicleAddons: {
    wings: optionItem({ quantity: "2", itemType: "TIN", location: "FRONT" }),
    roundIronSides: optionItem({ size: "10" }),
  },
  locks: {
    dieselLock: optionItem(),
    ureaLock: optionItem(),
    batteriesLock: optionItem(),
    hydraulicTailLiftMotorLock: optionItem(),
    hydraulicTailLiftLock: optionItem({ selectedOption: "HASP" }),
    spareWheelLock: optionItem(),
  },
  standard: {
    sideGuardsReflectors: optionItem({ selectedOption: "ALUMINUM" }),
    sideLighting: optionItem(),
    standardMudguards: optionItem(),
  },
};

export const mockQuoteForm: QuoteQuotationForm = {
  workHours: "0",
  perHour: "90",
  totalWorkCost: "0",
  repairHours: "0",
  sheetMetalCost: "0",
  craneCompletionAddition: "90",
  exchangeRate: "0",
  otherSaleItem: "0",
  variableCoefficient: "1.4",
  downPayment: "0",
  vehicleWeightWithoutSide: "0",
  assembledLength: "12000",
  assembledWidth: "2550",
  floorBase: "Z220",
  floorType: "BLACK_SHEET",
  floorThickness: "125",
  crossBeams: QuoteCrossBeams.OMEGA_3MM,
  reinforcedModel: false,
};
